export default "__VITE_ASSET__BFVbz6Fo__"